import { Accordion, AccordionDetails, AccordionSummary, Grid2 as Grid } from "@mui/material";
import { useStyles } from "./PriorityStock.styles";
import { PriorityStockGroupsProps } from "./types";
import { useMemo } from "react";
import { PRIORITY_STOCK_FLAG_CONFIG } from "./constants";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { PriorityStockGroupItems } from "./PriorityStockGroupItems";
import { FlagTag } from "./FlagTag";
export const PriorityStockGroups = ({
	priorityStockFlagsArray,
	purchaseOrderPriorityStock,
}: PriorityStockGroupsProps) => {
	const classes = useStyles();

	const available = useMemo(
		() => priorityStockFlagsArray.filter((flag) => purchaseOrderPriorityStock.priorityStock[flag]),
		[purchaseOrderPriorityStock, priorityStockFlagsArray]
	);

	const PriorityStockRows = useMemo(() => {
		return available
			.map((flag) => {
				const config = PRIORITY_STOCK_FLAG_CONFIG[flag];
				if (!config) return null;

				const { priorityClassName, Icon, iconProps } = config;

				return (
					<Grid key={flag} size={12}>
						<Accordion elevation={0} defaultExpanded className={classes.accordion}>
							<AccordionSummary
								className={`${classes.accordionSummary} ${classes[priorityClassName + "Accordion"]}`}
								expandIcon={<ExpandMoreIcon />}
							>
								<FlagTag
									flagName={flag}
									icon={<Icon {...iconProps} />}
									skusCount={purchaseOrderPriorityStock.priorityStock[flag].items.length}
									tagClassName={classes[priorityClassName]}
								/>
							</AccordionSummary>
							<AccordionDetails className={classes.accordionDetails}>
								<PriorityStockGroupItems items={purchaseOrderPriorityStock.priorityStock[flag].items} />
							</AccordionDetails>
						</Accordion>
					</Grid>
				);
			})
			.filter(Boolean);
	}, [available, purchaseOrderPriorityStock, classes]);

	return (
		<Grid container justifyContent="center" direction="column" spacing={2}>
			{PriorityStockRows}
		</Grid>
	);
};
